import axios from 'axios';
import { aplicarRenovacion, CABECERA_DE_RENOVACION, CABECERA_DE_SESION, obtenerSesion } from './sesionPortal';

const TOKEN_URL = process.env.REACT_APP_API_URL + "api/app/token/token";
const SUBSCRIPTION_KEY = process.env.REACT_APP_API_SUBSCRIPTION_KEY || "";

let cachedToken: string | null = null;
let tokenPromise: Promise<string> | null = null;

function cabecerasDeIdentidad(): Record<string, string> {
    const sesion = obtenerSesion();

    if (sesion) {
        return { [CABECERA_DE_SESION]: sesion };
    }

    const tokenPortal = sessionStorage.getItem("token");

    return tokenPortal ? { "X-Portal-Token": tokenPortal } : {};
}

async function fetchToken(): Promise<string> {
    const response = await axios.post(TOKEN_URL, undefined, {
        headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY,
            ...cabecerasDeIdentidad()
        }
    });

    aplicarRenovacion(response.headers?.[CABECERA_DE_RENOVACION]);

    const token = response.data?.response?.access_token ?? response.data?.access_token ?? response.data?.token ?? (typeof response.data === 'string' ? response.data : null);

    if (!token || typeof token !== 'string') {
        throw new Error("[TokenService] Token inválido recibido.");
    }

    return token;
}

export async function getToken(): Promise<string> {
    if (cachedToken) {
        return cachedToken;
    }

    if (tokenPromise) {
        return tokenPromise;
    }

    tokenPromise = fetchToken()
        .then(token => {
            cachedToken = token;
            tokenPromise = null;
            return token;
        })
        .catch(err => {
            tokenPromise = null;
            throw err;
        });

    return tokenPromise;
}

export function clearToken(): void {
    cachedToken = null;
    tokenPromise = null;
}
